import { render } from "./PuntoPickMpio.vue?vue&type=template&id=3d5de145"
import script from "./PuntoPickMpio.vue?vue&type=script&lang=ts"
export * from "./PuntoPickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script